export const UNDEFINED_ERROR = -1;
export const USER_NOT_ACTIVATED = 1;
export const MISSING_USER_DETAILS = 2;
export const NOT_LOGGED_IN = 3;
export const WRONG_COUPON_CODE = 4;
export const VALIDATION_ERROR = 4;
